import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=555e8480&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=555e8480&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555e8480",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('555e8480')) {
      api.createRecord('555e8480', component.options)
    } else {
      api.reload('555e8480', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=555e8480&scoped=true&", function () {
      api.rerender('555e8480', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bopLGgPRloRQ/JS/comp/SearchFilterTokens.vue"
export default component.exports